import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const ACTIVE_STAGES = [
    { 'state': 'info_requested', 'label': 'Information', 'sub': 'Tell us about your business' },
    { 'state': 'sub_account_pending', 'label': 'Account Setup', 'sub': 'Provisioning your CRM' },
    { 'state': 'phone_provisioning', 'label': 'Phone Number', 'sub': 'Assigning your number' },
    { 'state': 'a2p_pending', 'label': 'Carrier Approval', 'sub': 'Awaiting 10DLC approval (1-7 days)' },
    { 'state': 'active', 'label': 'Active', 'sub': 'You are live' },
];
const stateIndex = (state) => {
    const i = ACTIVE_STAGES.findIndex((x) => x.state === state);
    return i === -1 ? 0 : i;
};
export default (props) => {
    const currentIdx = stateIndex(props.state);
    return _jsx("div", { className: "d-flex flex-wrap gap-2 align-items-stretch", children: ACTIVE_STAGES.map((stage, idx) => {
            const isCurrent = idx === currentIdx;
            const isComplete = idx < currentIdx;
            const color = isComplete ? 'success' : isCurrent ? 'primary' : 'secondary';
            const opacity = isComplete || isCurrent ? 1 : 0.5;
            return _jsxs("div", { className: `flex-grow-1 border border-${color} rounded p-2`, style: { 'opacity': opacity, 'minWidth': '140px' }, children: [_jsxs("div", { className: "d-flex align-items-center gap-2 mb-1", children: [_jsx("span", { className: `badge bg-${color} rounded-circle`, style: { 'width': '1.5rem', 'height': '1.5rem' }, children: isComplete ? '✓' : idx + 1 }), _jsx("strong", { className: `text-${color}`, children: stage.label })] }), _jsx("div", { className: "small text-muted", children: stage.sub })] }, stage.state);
        }) });
};
